<se-fe-modal #modal
  (seFeAfterClose)="onAfterClose()">
  <se-fe-modal-content>
    @if (loaded) {
      <se-fe-header [seFeDataTitle]="translationKey + 'title' | translate" seFeDataSize="section">
        <se-fe-icon-button seFeHeaderActions [seFeDataSmall]="true" (click)="onClose()">
          <se-fe-icon
            seFeDataName="close"
            seFeDataSize="500"
            seFeDataAriaLabel="close">
          </se-fe-icon>
        </se-fe-icon-button>
      </se-fe-header>
    }
  </se-fe-modal-content>
  @if (loaded && persona) {
    <div seFeModalContent>
      @if (error) {
        <se-fe-alert
          class="invite-error"
          seFeDataType="error"
          >
          {{ error }}
        </se-fe-alert>
      }
      <div>
        @switch (step) {
          @case (stepEnum.Invite) {
            <se-po-invite #invite
              [persona]="persona"
              (inviteAdded)="onInviteAdded($event)"
              (inviteSkipped)="onSkip()">
            </se-po-invite>
          }
          @case (stepEnum.InviteReview) {
            <se-po-invite-review
              [invites]="invites"
              [guardianEmails]="guardianEmails"
              (back)="onStart()"
              (cancel)="onCancel($event)"
              (continue)="onContinue()">
            </se-po-invite-review>
          }
        }
      </div>
    </div>
  }
</se-fe-modal>
<se-fe-toast></se-fe-toast>
